'use client';

import React__default, { useRef, useState, useEffect } from 'react';
import { LabelWrapper, TextDanger, CompanySelectContainer, Input, InputWrapper, CompanyLogo, SearchIcon, RemovedIconWrapper, RemovedIcon, DropdownList, DropdownItem } from './styles.js';
import useFetch from '../hooks/useFetch.js';
import '../_virtual/_tslib.js';
import useDebounce from '../hooks/useDebounce.js';
import useFloating from '../hooks/useFloating/index.js';
import useClickAway from '../hooks/useClickAway.js';
import '../hooks/useMakeSearchable/types.js';
import { ELanguage } from '../Utils/constants.js';
import '../services/resumes/types.js';

var LIMIT = 5;
var CompanySelect = function (_a) {
    var _b;
    var label = _a.label, isRequired = _a.isRequired, msBasePath = _a.msBasePath, _c = _a.langCode, langCode = _c === void 0 ? ELanguage.VI : _c, _d = _a.placeholder, placeholder = _d === void 0 ? 'Search' : _d, _e = _a.limit, limit = _e === void 0 ? LIMIT : _e, onChange = _a.onChange, _f = _a.companyLogoUrl, companyLogoUrl = _f === void 0 ? '' : _f, _g = _a.companyName, companyName = _g === void 0 ? '' : _g, onInputChange = _a.onInputChange, onFocus = _a.onFocus, onBlur = _a.onBlur, _h = _a.apiEndPoint, apiEndPoint = _h === void 0 ? '/hot-keywords/api/v2/keywords/suggestion-company' : _h, _j = _a.hasError, hasError = _j === void 0 ? false : _j, _k = _a.defaultLogo, defaultLogo = _k === void 0 ? 'https://images.vietnamworks.com/img/company-default-logo.svg' : _k, renderOptions = _a.renderOptions, _l = _a.searchWithEmptyQuery, searchWithEmptyQuery = _l === void 0 ? false : _l, floatingConfig = _a.floatingConfig, _m = _a.isInputOnly, isInputOnly = _m === void 0 ? false : _m, _o = _a.inputStyle, inputStyle = _o === void 0 ? {} : _o, isAlwaysUpdateValue = _a.isAlwaysUpdateValue;
    var isFirstMounted = useRef(true);
    var isUserTouched = useRef(false);
    var inputRef = useRef(null);
    var _p = useState(''), inputValue = _p[0], setInputValue = _p[1];
    var _q = useState(''), selectedLogo = _q[0], setSelectedLogo = _q[1];
    var debouncedInputValue = useDebounce(inputValue, 300);
    var _r = useState('none'), removedIconState = _r[0], setRemovedIconState = _r[1];
    /*
     * Sync data
     * */
    useEffect(function () {
        /*
         * Check for user touched component
         * I only want data only sync when user not touched component
         * */
        if (isUserTouched.current && !isAlwaysUpdateValue) {
            return;
        }
        if (companyName !== '') {
            setInputValue(companyName);
        }
        /*
         * If has companyLogoUrl, setSelectedLogo.
         * If companyLogoUrl is empty and companyName not empty, setSelectedLogo by DEFAULT_COMPANY_LOGO
         * */
        if (companyLogoUrl !== '') {
            setSelectedLogo(companyLogoUrl);
            return;
        }
        if (companyName !== '') {
            setSelectedLogo(defaultLogo);
        }
    }, [companyLogoUrl, companyName, defaultLogo]);
    /*
     * Handle fetch and store data
     * */
    var _s = useState([]), options = _s[0], setOptions = _s[1];
    var SUGGESTION_COMPANY_API = "".concat(msBasePath).concat(apiEndPoint);
    useFetch(SUGGESTION_COMPANY_API + "?query=".concat(debouncedInputValue, "&limit=").concat(limit), {
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': langCode
        },
        enable: searchWithEmptyQuery || debouncedInputValue !== ''
    }, function (data) {
        if (renderOptions) {
            var options_1 = renderOptions(data);
            setOptions(options_1);
            return;
        }
        setOptions(data.data.map(function (item) { return item.attributes; }));
    });
    /*
     * Setup auto placement for dropdown element
     * */
    var _t = useState(false), isVisible = _t[0], setElementVisible = _t[1];
    var _u = useFloating({
        placement: 'bottom-start',
        position: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.position) || 'absolute',
        config: {
            detectHidden: true,
            useWindowAsFlippingContainer: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.useWindowAsFlippingContainer) || false
        }
    }), refs = _u.refs, context = _u.context, FloatingPortal = _u.FloatingPortal;
    /*
     * Setup handle click outside
     * */
    useClickAway(function () {
        setElementVisible(false);
    }, {
        nodeRefs: [refs.popup, refs.reference]
    });
    useEffect(function () {
        /*
         * Check for first mounted
         * This will make sure the selectedLogo won't be reset
         * */
        if (isFirstMounted.current) {
            isFirstMounted.current = false;
            return;
        }
        // End check
        if (inputValue === '') {
            /*
             * Reset option and logo when input value is empty string
             * */
            setOptions([]);
            setSelectedLogo('');
        }
    }, [inputValue]);
    var handleClearInput = function () {
        if (selectedLogo !== '') {
            setSelectedLogo('');
        }
        setInputValue('');
        onInputChange && onInputChange('');
    };
    return (React__default.createElement("div", null,
        label ? (React__default.createElement(LabelWrapper, null,
            isRequired ? React__default.createElement(TextDanger, null, "*") : null,
            " ",
            React__default.createElement("label", null, label))) : null,
        React__default.createElement(CompanySelectContainer, { onMouseEnter: function () { return removedIconState !== 'focus' && setRemovedIconState('hover'); }, onMouseLeave: function () { return removedIconState !== 'focus' && setRemovedIconState('none'); } },
            isInputOnly ? (React__default.createElement("div", { ref: refs.setReference },
                React__default.createElement(Input, { ref: inputRef, placeholder: placeholder, onBlur: function (e) {
                        setRemovedIconState('none');
                        onBlur && onBlur(e.target.value);
                    }, onFocus: function () {
                        setElementVisible(true);
                        setRemovedIconState('focus');
                        onFocus && onFocus();
                    }, onChange: function (e) {
                        isUserTouched.current = true;
                        // Reset logo when user input
                        if (selectedLogo !== '') {
                            setSelectedLogo('');
                        }
                        var companyName = e.target.value;
                        setInputValue(companyName);
                        onInputChange && onInputChange(companyName);
                    }, value: inputValue, style: inputStyle }))) : (React__default.createElement(InputWrapper, { hasError: hasError, ref: refs.setReference, onClick: function () {
                    if (inputRef && inputRef.current) {
                        inputRef.current.focus();
                        onFocus && onFocus();
                        setRemovedIconState('focus');
                    }
                } },
                selectedLogo !== '' ? (React__default.createElement(CompanyLogo, { width: 24, height: 24, src: selectedLogo, alt: 'Company logo' })) : (React__default.createElement(SearchIcon, null)),
                React__default.createElement(Input, { ref: inputRef, placeholder: placeholder, onBlur: function (e) {
                        setRemovedIconState('none');
                        onBlur && onBlur(e.target.value);
                    }, onFocus: function () {
                        setElementVisible(true);
                        setRemovedIconState('focus');
                        onFocus && onFocus();
                    }, onChange: function (e) {
                        isUserTouched.current = true;
                        // Reset logo when user input
                        if (selectedLogo !== '') {
                            setSelectedLogo('');
                        }
                        var companyName = e.target.value;
                        setInputValue(companyName);
                        onInputChange && onInputChange(companyName);
                    }, value: inputValue, style: inputStyle }),
                React__default.createElement(RemovedIconWrapper, { className: "".concat(removedIconState === 'none' ? 'hidden' : inputValue === '' ? 'hidden' : '') },
                    React__default.createElement(RemovedIcon, { onClick: handleClearInput })))),
            (isVisible || (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === (document === null || document === void 0 ? void 0 : document.activeElement)) && options.length > 0 ? (React__default.createElement(FloatingPortal, { enable: floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.enablePortal },
                React__default.createElement(DropdownList, { "data-floating-placement": context.placement, ref: refs.setPopup, style: {
                        position: context.position,
                        top: context.y + ((floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.y) || 0),
                        left: context.x + ((floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.x) || 0),
                        display: context.isReferenceHidden ? 'none' : 'block',
                        width: context.position === 'fixed'
                            ? (((_b = refs.reference.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0) + 'px'
                            : '100%',
                        zIndex: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.zIndex) || 1099
                    } }, options.map(function (option, index) {
                    return (React__default.createElement(DropdownItem, { key: "".concat(option.companyName, "-").concat(index), onClick: function () {
                            isUserTouched.current = true;
                            setInputValue(option.companyName);
                            setSelectedLogo(option.companyLogoUrl || defaultLogo);
                            setElementVisible(false);
                            onChange(option);
                        } },
                        React__default.createElement(CompanyLogo, { width: 24, height: 24, src: option.companyLogoUrl || defaultLogo, alt: 'Company logo' }),
                        option.companyName));
                })))) : null)));
};

export { CompanySelect as default };
//# sourceMappingURL=index.js.map
